module.exports = __webpack_public_path__ + "img/Trillionaire-3.e18d9d38.gif";